var exports = {
  "id": "x31de4314--508520--discount",
  "_R": "x31de4314--508520--original-price",
  "ip": "x31de4314--508520--discount-percent",
};

module.exports = exports;
